import React, {useState} from 'react'
import styled from 'styled-components'
import {Button, IconButton} from '../buttons'

const Header = styled.header`
  margin: 0;
  padding: 15px 0;
  display: flex;
  align-items: center;
  > h3 {
    margin: 0;
    flex: 1;
  }
`

const ButtonWrap = styled.div`
  margin-right: -10px;
`

const Content = styled.div``

const Section = styled.section<{expanded: boolean}>`
  padding: ${({expanded}) => (expanded ? '10px 30px 30px' : '10px 30px 10px')};
  &:not(:last-of-type) {
    border-bottom: 1px solid ${p => p.theme.grey10};
  }
  > ${Content} {
    display: ${({expanded}) => (expanded ? 'block' : 'none')};
  }
`

interface CollapsibleSectionProps {
  children: React.ReactNode
  title: string | JSX.Element
  defaultExpanded?: boolean
  handleClose?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  style?: React.CSSProperties
}
export const CollapsibleSection = ({
  children,
  title,
  defaultExpanded = true,
  handleClose,
  style
}: CollapsibleSectionProps) => {
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded)

  return (
    <Section expanded={expanded} style={style}>
      <Header>
        <h3>{title}</h3>
        <ButtonWrap>
          {!handleClose ? (
            <Button
              onClick={() => {
                setExpanded(!expanded)
              }}
              variant={'greyscale'}
              weight={'light'}
              size={'small'}
              appearance={'transparent'}
            >
              {expanded ? (handleClose ? 'Close subview' : 'Hide') : 'Show'}
            </Button>
          ) : (
            <div style={{margin: '-5px 0px'}}>
              <IconButton
                appearance="transparent"
                onClick={handleClose}
                icon="close"
                size="large"
              ></IconButton>
            </div>
          )}
        </ButtonWrap>
      </Header>
      <Content>{children}</Content>
    </Section>
  )
}
